import axios from "axios";
import { useState, useEffect } from "react";
import { useQuery } from "react-query";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { BASE_URL } from "../utils/util";

dayjs.extend(duration);

const FooterFlag = ({ value }: { value: string }) => {
  const { data: classLive, isLoading: classLiveLoading } = useQuery(
    "메인_보수교육_LIVE",
    () =>
      axios.get(`${BASE_URL}/home/KVStore/메인_보수교육_LIVE`).then((res) => res.data.store?.value),
    { cacheTime: Infinity, staleTime: 15 * 60 * 1000 },
  );

  const { data: groupBuyingTag, isLoading: groupBuyingTagLoading } = useQuery(
    "메인_groupbuying",
    () => axios.get(`${BASE_URL}/home/KVStore/groupbuying`).then((res) => res.data.store?.value),
    { cacheTime: Infinity, staleTime: 15 * 60 * 1000 },
  );

  const isDate = (value: string | number) => {
    if (typeof value !== "string" && typeof value !== "number") return false;

    // MARK: 기존 로직에서 'D-1' 같은 문자열도 isDate가 true로 판단되는 문제가 있어서 format을 한정시킵니다.
    // MARK: yyyy-mm-dd | yyyy:mm:dd | yy-mm-dd | yy:mm:dd
    const isoDateRegex = /^(?:\d{4}|\d{2})[-:]\d{2}[-:]\d{2}$/;
    if (!isoDateRegex.test(value.toString())) return false;

    const date = new Date(value.toString());
    return date instanceof Date && !isNaN(date.getTime());
  };

  if (value === "class" && !classLiveLoading && classLive && isDate(classLive))
    return <Timer dateString={classLive} />;

  if (value === "class" && !classLiveLoading && classLive && !isDate(classLive))
    return (
      <>
        <span className="bg-[#FF228C] z-10 whitespace-nowrap absolute !text-white px-2 font-semibold py-[2px] text-[11px] rounded-sm left-[50%] translate-x-[-50%] top-[-15px]">
          {classLive}
        </span>
        <div className="absolute w-0 h-0 border-[8px] border-solid border-transparent border-t-[#FF228C] top-0 left-[50%] translate-x-[-50%]"></div>
      </>
    );

  if (value === "market" && !groupBuyingTagLoading && groupBuyingTag && isDate(groupBuyingTag))
    return <Timer dateString={groupBuyingTag} />;

  if (value === "market" && !groupBuyingTagLoading && groupBuyingTag && !isDate(groupBuyingTag))
    return (
      <>
        <span className="bg-[#FF228C] z-10 whitespace-nowrap absolute !text-white px-2 font-semibold py-[2px] text-[11px] rounded-sm left-[50%] translate-x-[-50%] top-[-15px]">
          {groupBuyingTag}
        </span>
        <div className="absolute w-0 h-0 border-[8px] border-solid border-transparent border-t-[#FF228C] top-0 left-[50%] translate-x-[-50%]"></div>
      </>
    );

  return null;
};

export default FooterFlag;

function Timer({ dateString }: { dateString: string | number }) {
  const [timeRemaining, setTimeRemaining] = useState<{
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
  } | null>(null);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const targetDate = dayjs(dateString).startOf("day").add(0, "hour");
      const now = dayjs();
      const diff = targetDate.diff(now);
      if (diff <= 0) {
        // 날짜가 이미 지났으면 타이머를 멈춥니다.
        clearInterval(intervalId);
        setTimeRemaining(null);
        return;
      }
      const duration = dayjs.duration(diff);
      setTimeRemaining({
        days: duration.days(),
        hours: duration.hours(),
        minutes: duration.minutes(),
        seconds: duration.seconds(),
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, [dateString]);

  if (!timeRemaining) {
    return <></>;
  }

  return (
    <>
      <span className="bg-[#FF228C] z-10 whitespace-nowrap absolute !text-white px-2 font-semibold py-[2px] text-[11px] rounded-sm left-[50%] translate-x-[-50%] top-[-15px]">
        {timeRemaining.days > 0 && <span>{timeRemaining.days}일&nbsp;</span>}
        {timeRemaining.hours.toString().padStart(2, "0")}:
        {timeRemaining.minutes.toString().padStart(2, "0")}:
        {timeRemaining.seconds.toString().padStart(2, "0")} 남음
      </span>
      <div className="absolute w-0 h-0 border-[8px] border-solid border-transparent border-t-[#FF228C] top-0 left-[50%] translate-x-[-50%]"></div>
    </>
  );
}
